import React from 'react';
import { FaWifi } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './WeakNetworkNotification.css';

const WeakNetworkNotification = ({ onRetry }) => {
  const navigate = useNavigate();

  const handleRetry = () => {
    if (onRetry) onRetry();
    navigate('/');
  };

  return (
    <div className="notification-wrapper">
      <FaWifi className="wifi-icon" />
      <span>Mạng yếu, không thể tiếp tục kết nối.</span>
      <button className="retry-button" onClick={handleRetry}>
        Thử lại
      </button>
    </div>
  );
};

export default WeakNetworkNotification;